export default __webpack_public_path__ + "static/media/property_742.90a4ffb7.png";